document.addEventListener("DOMContentLoaded", function () {
    'use strict';
    
    var components = Array.prototype.slice.call(document.querySelectorAll("[data-js-init]"));
    
    components.forEach(function (component) {
        var
            initCommandStr = component.dataset.jsInit,
            tmp, 
            command,
            initArgNamesStr = component.dataset.jsArgNames,
            initArgNames = initArgNamesStr ? initArgNamesStr.split(',') : [],
            initArgs = [];
        
        try {
            //console.log("initCommandStr:", initCommandStr);
            tmp = eval(initCommandStr);
        } catch (e) {
            console.debug("Failed to initialize ", initCommandStr);
            console.debug(e);
            return;
        }

        initArgNames.forEach(function (argName) {
           initArgs.push(component.dataset[argName]); 
        });
        initArgs.push(component.dataset);
        
        if (typeof(tmp) === "function") {
            command = tmp;
        } else if (tmp["initialize"] && typeof(tmp["initialize"]) === "function") {
            command = tmp["initialize"];
        }
        
        if (command) {
            command.apply(component, [component].concat(initArgs));
        }
    });
});

(function () {
	var
        searchActivator = document.querySelector('#search-toggle');
        if (searchActivator !== null) {
            searchActivator.addEventListener('click', function (e) {
                document.querySelector('#search-input').focus();
            });        
        }
})();

(function () {
    'use strict';
    
    var links = Array.prototype.slice.call(document.querySelectorAll('.main-nav__link'));
    var pathRegex = new RegExp('^' + location.pathname + '$', 'i');
    links.forEach(function (link) {
        if (pathRegex.test(link.pathname) && !link.classList.contains('js-featured')) {
            link.classList.add('selected');
        } 
    });
})();

(function () {
    'use strict';
    
    window.utils = window.utils || {};
    window.utils.getSelectedOptionValues = function (name) {
        // Pass the checkbox name to the function
        var options = Array.prototype.slice.call(document.getElementsByName(name));
        var values = [];
        // loop over them all
        options.forEach(function (option, i) {
        	if (option.checked && (option.dataset.value /*|| option.dataset.value === ''*/)) {
                values.push(option.dataset.value);
            } 
        });
        // Return the array if it is non-empty, or null
        return values.length > 0 ? values : null;
    };

    window.utils.getOptionValues = function (name) {
    	// Pass the checkbox name to the function
    	var options = Array.prototype.slice.call(document.getElementsByName(name));
    	var values = [];
    	options.forEach(function (option, i) {
    		values.push(option.dataset.value);
    	});
    	return values;
    }

    window.utils.selectorMatches = function(el, selector) {
    	var p = Element.prototype;
    	var f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function (s) {
    		return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
    	};
    	var result = null;
    	try {
    		result = f.call(el, selector);
		} catch (err) {
    		console.debug('window.utils.selectorMatches failed. Arguments:', arguments);
    	}
    	return result;
    }

    window.utils.querySelectorParent = function (elm, selector) {
    	var
			match = null,
			parent = elm.parentNode;
    	while (!match && parent) {
    		if (utils.selectorMatches(parent, selector)) {
    			match = parent;
    		}
    		parent = parent.parentNode;
    	}
    	return match;
    }

    window.utils.cookie = {};

    window.utils.cookie.get = function (sName) {
    	var
			sCookie = "; " + document.cookie,
			aParts = sCookie.split("; " + sName + "="),
			sReturn = "";
    	if (aParts.length == 2) sReturn = aParts.pop().split(";").shift();
    	return sReturn;
    }

    window.utils.cookie.rem = function (sName) {
    	document.cookie = sName + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    }

    window.utils.cookie.set = function (sName, sValue, bSession, bLocal) {
    	bSession = bSession || false;
    	bLocal = bLocal || false;		// if local don't set the path and thereby make the cookie only available on the given page.
    	var
			oDate = new Date();
    	oDate.setFullYear(oDate.getFullYear() + 1);
    	document.cookie = sName + "=" + sValue + (!bLocal ? ";path=/; " : "") + (!bSession ? "expires=" + oDate.toGMTString() : "");
    }

})();


